/**
 * BETA — notification bell + supplier requests.
 */
import { httpError } from "../router.js";
import { paginate, nowIso } from "./_utils.js";

export function register(route) {
  const listHandler = (ctx) => {
    const { params, store } = ctx;
    let rows = [...(store.data.notifications || [])];
    if (params.unread_only === "true" || params.unread_only === true) {
      rows = rows.filter((n) => !n.lu);
    }
    rows.sort((a, b) => (a.date_creation > b.date_creation ? -1 : 1));
    return paginate(rows, params);
  };
  route("GET", "/notifications", listHandler);
  route("GET", "/notifs", listHandler);

  route("GET", "/notifications/count", (ctx) => ({
    unread: (ctx.store.data.notifications || []).filter((n) => !n.lu).length,
  }));

  route("POST", "/notifications/:id/read", (ctx) => {
    const n = (ctx.store.data.notifications || []).find((x) => x.id === ctx.params.id);
    if (!n) httpError(404, "Notification introuvable", "NOT_FOUND");
    n.lu = true;
    n.date_lecture = nowIso();
    ctx.commit();
    return n;
  });

  route("POST", "/notifications/read-all", (ctx) => {
    let count = 0;
    for (const n of ctx.store.data.notifications || []) {
      if (!n.lu) {
        n.lu = true;
        n.date_lecture = nowIso();
        count += 1;
      }
    }
    ctx.commit();
    return { success: true, count };
  });

  route("POST", "/notifs/lue", (ctx) => {
    const ids = ctx.body?.ids || [];
    let count = 0;
    for (const n of ctx.store.data.notifications || []) {
      if (ids.includes(n.id) && !n.lu) {
        n.lu = true;
        count += 1;
      }
    }
    ctx.commit();
    return { success: true, count };
  });

  route("GET", "/notifications/suppliers/pending", (ctx) => paginate(ctx.store.data.pendingSuppliers || [], ctx.params));

  route("PATCH", "/notifications/suppliers/:id/accept", (ctx) => {
    ctx.store.data.pendingSuppliers = (ctx.store.data.pendingSuppliers || []).filter((p) => p.id !== ctx.params.id);
    ctx.commit();
    return { success: true };
  });

  route("PATCH", "/notifications/suppliers/:id/reject", (ctx) => {
    ctx.store.data.pendingSuppliers = (ctx.store.data.pendingSuppliers || []).filter((p) => p.id !== ctx.params.id);
    ctx.commit();
    return { success: true };
  });
}
